import {
  ADD_TEMPLATE,
  ADD_TEMPLATE_FAIL,
  ADD_TEMPLATE_SUCCESS,
  DELETE_TEMPLATE,
  DELETE_TEMPLATE_FAIL,
  DELETE_TEMPLATE_SUCCESS,
  GET_TEMPLATES_LIST,
  GET_TEMPLATES_LIST_FAIL,
  GET_TEMPLATES_LIST_SUCCESS,
} from "./actionTypes";

export const getTemplatesList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_TEMPLATES_LIST,
  payload: { data, onSuccess, onError },
});
export const getTemplatesListSuccess = (data = {}) => ({
  type: GET_TEMPLATES_LIST_SUCCESS,
  payload: data,
});
export const getTemplatesListFail = (data = {}) => ({
  type: GET_TEMPLATES_LIST_FAIL,
  payload: data,
});

export const addTemplate = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_TEMPLATE,
  payload: { data, onSuccess, onError },
});
export const addTemplateSuccess = (data = {}) => ({
  type: ADD_TEMPLATE_SUCCESS,
  payload: data,
});
export const addTemplateFail = (data = {}) => ({
  type: ADD_TEMPLATE_FAIL,
  payload: data,
});

export const deleteTemplate = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_TEMPLATE,
  payload: { data, onSuccess, onError },
});
export const deleteTemplateSuccess = (data = {}) => ({
  type: DELETE_TEMPLATE_SUCCESS,
  payload: data,
});
export const deleteTemplateFail = (data = {}) => ({
  type: DELETE_TEMPLATE_FAIL,
  payload: data,
});
